import React from 'react';

import { FilterContext } from '../../../Context/FilterContext';

interface Props {
    toggleVisibility: () => void;
}

const LoggedOutFilterPanel: React.FunctionComponent<Props> = (props) => {
    const { standardFilterValues } = React.useContext(FilterContext);

    if (standardFilterValues) {
        return (
            <div className="product-filter__panel space-between">
                <div className="product-filter__panel-contents">
                    <p>
                        <strong>Aktiver Filter:</strong> Standardfilter
                    </p>
                </div>
                <button
                    className="product-filter__button button button--secondary"
                    onClick={props.toggleVisibility}
                    type="button"
                >
                    ändern
                </button>
            </div>
        );
    } else {
        return (
            <div className="product-filter__panel">
                <div className="product-filter__label">Filter:</div>
                <button
                    className="product-filter__button button button--secondary"
                    onClick={props.toggleVisibility}
                    type="button"
                >
                    Filter wählen
                </button>
            </div>
        );
    }
};

export default LoggedOutFilterPanel;
